// extracted by mini-css-extract-plugin
export default {"layout":"_938e02d8ed _5c9229d3cd _9b0ef8090d","h_slide":"d31535c73c","category":"fe11ff4ac2 a3c6d87c4c f1a9549b05"};